import { useBulkPricingActionsPermissions } from 'src/components/common/BulkActions/BulkPricingActions/useBulkPricingActionsPermissions';
import { Content } from 'src/contexts/ContentContext';
import { PosDropdownItem } from 'src/core/POS/PosDropdown';
import { ContentId } from 'src/utils/constants/contentId';

export const LaunchUpdateMarketplacePrices = ({
  onClick,
  disabled,
}: {
  onClick: (e: React.MouseEvent<HTMLButtonElement>) => void;
  disabled?: boolean;
}) => {
  const { hasUpdateListingPermission, hasEditPricingPermission } =
    useBulkPricingActionsPermissions();

  if (!hasUpdateListingPermission) {
    return null;
  }

  if (!hasEditPricingPermission) {
    return null;
  }

  return (
    <PosDropdownItem
      key={'MarketplacePrices'}
      onClick={onClick}
      disabled={disabled}
    >
      <Content id={ContentId.UpdateMarketplacePrices} />
    </PosDropdownItem>
  );
};
